module.exports = __webpack_public_path__ + "static/media/CallRestaurantScreen.7bfc475a.png";